var WDN = WDN || {};

if (typeof WDN.Select === "undefined") {
  WDN.Select = (function () {
    class WDNSelect extends WDN.Component {
      constructor() {
        super();
        this.id = this.getAttribute("data-id") || false;
        this.isActive = false;
        this.trigger = this.querySelector("[data-trigger]");
        this.placeholder = this.querySelector("[data-placeholder]");
        this.container = this.querySelector("[data-container]");
        this.content = this.querySelector("[data-content]");
        this.options = this.querySelectorAll("wdn-option");
        this.isDisabled = this.getAttribute("data-disabled") == "";
        this.selected_option = this.querySelector("wdn-option[data-selected]");
        this.noShrink = this.getAttribute("data-no-shrink") == "";
        this.has_default_option = this.getAttribute("data-single-option") == "";
        this.init();
      }

      setContainerHeight(newHeight) {
        this.container.style.height = newHeight + "px";
      }

      active(newState) {
        if (newState) {
          this.setAttribute("data-active", "");
        } else {
          this.removeAttribute("data-active");
        }

        this.isActive = newState;
      }

      expandContainer() {
        if (this.noShrink) return;
        this.active(true);
        this.setContainerHeight(this.content.offsetHeight);
        this.bindBody();
        this.callback("onExpand");
      }

      shrinkContainer() {
        if (this.noShrink) return;
        this.active(false);
        this.setContainerHeight(0);
        this.unbindBody();
        this.callback("onShrink");
      }

      clearActiveOption() {
        if (!this.selected_option) return;
        this.selected_option = !this.selected_option.deselect();
      }

      setTriggerState(newState) {
        if (!this.trigger) return;
        this.trigger.setAttribute("data-state", newState);
      }

      triggerOnClick() {
        if (this.isDisabled) return;
        if (this.has_default_option) {
          this.callback("onSingleOption");
          return;
        }
        if (this.isActive) {
          this.shrinkContainer();
        } else {
          this.expandContainer();
        }
      }

      getOptionByValue(reqValue) {
        var foundOption = false;
        this.options.forEach(function (option) {
          if (option.value == reqValue) {
            foundOption = option;
          }
        });

        return foundOption;
      }

      setActiveOptionByValue(value) {
        var requestedOption = this.getOptionByValue(value);
        if (!requestedOption) return;
        this.setActiveOption(requestedOption);
      }

      // refactor
      setActiveOption(option) {
        if (!option || option.isDisabled || option.value == "") return;
        this.clearActiveOption();
        this.selected_option = option.select();
        this.setPlaceholder(this.selected_option.label);
      }

      optionOnClick(e) {
        var option = e.currentTarget;
        this.setActiveOption(option);
        this.shrinkContainer();
        this.fireEvent({ name: "option:selected", detail: this });
        typeof this.onOptionSelect === "function" ? this.onOptionSelect(this) : false;
      }

      setPlaceholder(newPlaceholder) {
        if (!this.placeholder) return;
        this.placeholder.innerHTML = newPlaceholder;
        this.placeholder_value = newPlaceholder;
      }

      bodyOnClick(e) {
        if (!this.contains(e.target)) {
          this.shrinkContainer();
        }
      }

      bindBody() {
        this.bindElement(document.body, "click", this.bodyOnClickBound);
      }

      unbindBody() {
        this.unbindElement(document.body, "click", this.bodyOnClickBound);
      }

      onWindowResize() {
        if (this.isActive) {
          this.setContainerHeight(this.content.offsetHeight);
        }
      }

      bind() {
        this.bodyOnClickBound = this.bodyOnClick.bind(this);
        this.bindElement(window, "resize", this.onWindowResize.bind(this));
        this.bindElement(this.trigger, "click", this.triggerOnClick.bind(this));
        this.bindElements(this.options, "click", this.optionOnClick.bind(this));
      }

      setInitialState() {
        if (this.selected_option) {
          this.setPlaceholder(this.selected_option.label);
          if (!this.selected_option.label) {
            setTimeout(
              function () {
                this.setPlaceholder(this.selected_option.label);
              }.bind(this),
              200
            );
          }
        }
      }

      init() {
        this.setInitialState();
        this.bind();
      }
    }

    customElements.define("wdn-select", WDNSelect);

    return WDNSelect;
  })();
}
